import request from '../../utils/request';

export async function getCsmMarketConfigListRequest(params) {
  return request({
    url: 'csmMarket/config/list',
    method: 'get',
    headers: 'json',
    params,
  });
}
export async function addCsmMarketConfigRequest(params) {
  return request({
    url: 'csmMarket/config/add',
    method: 'post',
    headers: 'json',
    params,
  });
}
export async function updateCsmMarketConfigRequest(params) {
  return request({
    url: 'csmMarket/config/update',
    method: 'post',
    headers: 'json',
    params,
  });
}
export async function deleteCsmMarketConfigRequest(params) {
  return request({
    url: 'csmMarket/config/delete',
    method: 'post',
    headers: 'json',
    params,
  });
}
